import {TranslateService} from '@ngx-translate/core';
import {Filter,TypeComparaison} from '@domain/common/list-view';
import {AutocompleteOptions} from '../autocomplete';
import {SearchType} from "@domain/common/list-view/sorting";
import {OpeCarteLineItemComponent} from "./ope-carte-line-item.component";
import {OpeCarteSearchItemComponent} from "./ope-carte-search-item";
import {environment} from "@environments/environment";
import {EtatOperation} from "@domain/opecarte/list-opecarte";

export default class OpeCarte implements AutocompleteOptions {
    url(filter: any) {
        //Initialisation du param
        const param: { UserId?: number } = {};

        //Si l'id de l'utilisateur est différent de celui de l'utilisateur connecté
        if (filter.idUser !== filter.connectedIdUser){
            param.UserId =  filter.idUser;
        }

        //URL pour récupérer la liste des OpeCarte
        let url: string = `${environment.baseUrl}/controller/OpeCarte/listeCarte${ param?.UserId ? ('/' + param?.UserId) : '' }`;
        return url;
    }

    searchItemComponent() { return OpeCarteSearchItemComponent; }

    displayItem(item: any) {
        return [item?.mccLibelle || '', item?.dateVente ? new Date(item.dateVente).toLocaleDateString() : '', item?.montantAchat ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: item.deviseAchat }).format(item.montantAchat) : ''].filter(Boolean).join(' - ').trim();
    }

    lineItemComponent() { return OpeCarteLineItemComponent; }

    listeFilters(translateService: TranslateService): Array<Filter> {
        return [{
            title: translateService.instant('ndf.frais.fraisCarte.mccLibelle'),
            clef: 'mccLibelle',
            typeComparaison: TypeComparaison[TypeComparaison.LIKE],
            isDefault: true
        }];
    }

    listeStaticFilters(filter?: any): Array<Filter> {
        //Retour de la liste des filtres
        return [{
            clef: 'etatOperation',
            listeObjects: [EtatOperation.NON_JUSTIFIE, EtatOperation.PARTIELLEMENT_JUSTIFIE],
            typeComparaison: TypeComparaison[TypeComparaison.IN],
            isDefault: true
        }];
    }

    /**
     * Mode de recherche
     */
    searchType = SearchType.CONTAINS;
}